<template>
  <div v-if="news">
    <div class="newsContent hakkaBg">
      <div class="newsBar d-flex align-center">
        <div class="newsContentWapper">
          <div class="col-lg-10 col-12 ma-auto d-flex justify-space-between align-center">
            <v-btn
              fab
              elevation="0"
              color="#00000000"
              class="rounded-4 d-flex justify-start"
              width="100"
              height="40"
              @click="$router.go(-1)"
            >
              <v-icon class="main-text-color fz-12" style="width: 10px;">fa fa-chevron-left</v-icon>
              <h4 class="ml-2 main-text-color font-weight-regular">返回</h4>
            </v-btn>
            <h4 class="main-text-color ml-10" style="border-bottom: solid 1px">{{ type }}</h4>
          </div>
        </div>
      </div>

      <div class="newsBlock pt-md-6 pt-3">
        <div class="newsContentWapper">
          <div
            class="col-lg-10 col-12 ma-auto d-flex justify-md-space-between align-md-center flex-md-row flex-column"
          >
            <h2 class="main-text-color mb-md-0 mb-md-3 mb-8 hkH2">{{ news.title }}</h2>
            <div class="d-flex">
              <v-btn
                v-if="!fontSizeIsMin"
                @click="fontSizeDown"
                elevation="0"
                class="rounded-4 d-flex align-center mr-2 fontSizeBtn"
                ><h3>A</h3>
                <i class="ri-subtract-line"></i
              ></v-btn>
              <v-btn
                v-if="!fontSizeIsMax"
                @click="fontSizeUp"
                elevation="0"
                class="rounded-4 d-flex align-center fontSizeBtn"
                ><h3>A</h3>
                <i class="ri-add-line"></i
              ></v-btn>
            </div>
          </div>
          <div class="col-lg-10 col-12 ma-auto">
            <p class="mb-4 d-flex align-center newsSubtitle hkB1">
              <span v-if="news.author">【 {{ news.author }} 】</span>
              <i class="ri-time-line px-2"></i> {{news.created_at| moment('YYYY-MM-DD')}}
            </p>

            <newsMedia
              :news="news"
            ></newsMedia>

            <V-html 
              :html="content" 
              class="newsOgfont"
              :class="`size-${fontSize}`"
              component="p"
            ></V-html>

          </div>
          <div
            class="col-lg-10 col-12 ma-auto d-flex justify-lg-space-between flex-lg-row flex-column align-center py-5 newsShare mt-10"
          >

            <share-and-like
              type="news"
              :target-id="news.id"
              class="mb-md-0 mb-5"
            ></share-and-like>

            <div class="d-flex flex-wrap justify-md-end justify-center">

              <v-chip
                v-for="(tag, index) in tags"
                :key="index"
                class="rounded-0 white--text mr-2 mb-2"
                label
                color="rgb(77 77 77 / 65%)"
                :to="getNewsTagRoute(tag)"
              >
                {{ tag.tag }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>


      <v-lazy>
        <relativeNews
          :newsId="news.id"
        ></relativeNews>
      </v-lazy>
    </div>
  </div>
</template>

<script lang="babel" type="text/babel">
import html2plaintext from 'html2plaintext'
export default {
  metaInfo() {
    return {
      title: this.vueMeta.title,
      link: this.vueMeta.link,
      meta: this.vueMeta.meta,
      script: this.vueMeta.script,
    }
  },
  data: () => ({
    vueMeta: {
      title: '',
      link: [],
      meta: [],
      script: [],
    },
    news: null,
    fontSize: 18,
    fontSizeStep: 2,
  }),
  created() {
    this.$setPageGap(false)
    this.init()
    this.updateNewsWatchLog()
  },
  methods: {
    getNewsTagRoute(tag) {
      return {
        name: 'search',
        query: {
          q: tag.tag,
          filter: 'news',
          type: 'keywords',
        },
      }
    },
    async init() {
      this.news = null
      this.$store.dispatch('base/loading')
      try {
        this.news = await this.$api.news.public.read(this.id)
        this.setupMeta()
      } catch (error) {
        console.error(error)
        this.$ssr('error')
        if(error.status == '404') this.$router.replace({ name: '404' })
      } finally {
        this.$store.dispatch('base/loading', false)
      }
    },
    fontSizeUp() {
      if(this.fontSizeIsMax) return
      this.fontSize = this.fontSize + this.fontSizeStep
    },
    fontSizeDown() {
      if(this.fontSizeIsMin) return
      this.fontSize = this.fontSize - this.fontSizeStep
    },
    async setupMeta() {
      this.$tracking.pageView(this.news.title)
      this.vueMeta.title = this.pageTitle
      this.vueMeta.meta = this.$seo.getMetaArray({
        title: this.pageTitle,
        description: this.brief,
        photo: this.$helper.getPhotoObj({data: this.news, needPresetImg: true}),
      })

      const url = `${window.location.origin}${this.$route.path}`
      this.vueMeta.link = [{ rel: 'canonical', href: url }]

      await this.$nextTick()
      this.$ssr()
    },
    async updateNewsWatchLog() {
      if(!this.isMember) return
      this.$store.dispatch('base/loading')
      try {
        await this.$api.history.public.updateWatchLog('news', this.id)
      } catch(err) {
        console.error(err)
      } finally {
        this.$store.dispatch('base/loading', false)
      }
    },
  },
  computed: {
    isMember() {
      return this.$store.getters['token/isMember']
    },
    tags() {
      if(!this.news) return null
      if(!Array.isArray(this.news.tag)) return null
      return this.news.tag
    },
    content() {
      return !this.news ? null : this.news.content
    },
    brief() {
      if(typeof this.content != 'string') return null
      const string = html2plaintext(this.content)
      if(typeof string != 'string') return null
      return string.slice(0, 30)
    },
    pageTitle() {
      if(!this.news) return `新聞 - ${this.siteName}`
      return `${this.news.title} - ${this.siteName}`
    },
    siteName() {
      return this.$store.getters['base/siteName']
    },
    fontSizeIsMax() {
      return this.fontSize >= 20
    },
    fontSizeIsMin() {
      return this.fontSize <= 16
    },
    id() {
      return this.$route.params.id
    },
    type() {
      if(!this.$route.query) return null
      if(!this.$route.query.label) return null
      return this.$route.query.label
    },
  },
  watch: {
    id() {
      this.init()
      this.updateNewsWatchLog()
    },
  },
  components: {
    relativeNews: () => import('./relativeNews'),
    newsMedia: () => import('./newsMedia.vue'),
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>